export { default as useCounter } from './useCounter';
export * from './useCounter';
//# sourceMappingURL=index.js.map